/**
 * 手工输入适配器 —— 零依赖的兜底路径。
 *
 * 关键在于：它**完全在本地构造 IntakeDraft**，不请求服务端。
 * 因为归一化、品类推断这些逻辑本来就放在 @fridge/shared 里，
 * 前后端跑的是同一份代码。所以断网、模型挂了、服务端 500 —— 都不影响录食材。
 *
 * 这不是巧合，是架构决定的：只要共享层是纯函数，兜底路径就不需要网络。
 */

import {
  guessCategory,
  normalizeFoodName,
  type FoodCategory,
  type IntakeDraft,
  type IntakeItem,
} from '@fridge/shared';

export interface ManualDraftInput {
  name: string;
  qty?: number | null;
  unit?: string | null;
  category?: FoodCategory | null;
  /** 已经在冰箱里放了几天，0 表示今天放的 */
  storedDays?: number;
}

export function buildManualDraft(inputs: ManualDraftInput[]): IntakeDraft {
  const items: IntakeItem[] = [];

  for (const input of inputs) {
    const name = normalizeFoodName(input.name);
    if (!name) continue;
    items.push({
      name,
      qty: input.qty ?? null,
      unit: input.unit?.trim() || null,
      category: input.category ?? guessCategory(name),
      storedDays: Math.max(0, Math.round(input.storedDays ?? 0)),
      // 用户亲手敲的，不需要复核，直接给满分
      confidence: 1,
      raw: null,
    });
  }

  return {
    clientDraftId: `id_manual_${Date.now().toString(36)}`,
    source: 'manual',
    items,
    warnings: [],
    transcript: null,
    fallbackFrom: null,
    createdAt: new Date().toISOString(),
  };
}
